// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VR7Ha{gap:8px}.fOam0{display:flex;flex-direction:column;align-items:flex-start}.Uvmyo{width:100%}.yVmM2{display:flex;align-items:center;gap:8px;padding:0 8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContent": `VR7Ha`,
	"serviceDescriptionWrapper": `fOam0`,
	"serviceDescription": `Uvmyo`,
	"serviceItem": `yVmM2`
};
export default ___CSS_LOADER_EXPORT___;
